import { useEffect, useRef } from 'react';
import { SourceGroup } from 'helpers/axios';

const useSources = () => {
  const sources = useRef(new SourceGroup());
  useEffect(() => () => sources.current.cancelAll(), []);

  return sources.current;
};

export default useSources;
